import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface ExpandCollapseButtonProps {
  expanded: boolean;
  controls: string;
  label: string;
  onClick: () => void;
  className?: string;
}

export const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
  expanded,
  controls,
  label,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      aria-expanded={expanded}
      aria-controls={controls}
      aria-label={label}
      onClick={onClick}
      className={`inline-flex h-8 w-8 items-center justify-center rounded-md border border-[#D5DDE7] bg-white text-[#4A5565] hover:bg-[#F8FAFC] ${className}`}
    >
      {expanded ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronRight className="h-4 w-4" />
      )}
    </button>
  );
};
